export default function exclude(value, { exclude }) {
  /**
   * @description accept a prop of `exclude` to test the value, for excluding matching values.
   * @prop {string} value - <input /> string value.
   * @prop {string | string[]} exclude - values to disclude from input value.
   * @return { string | Component | null } error message, or `null` if the value is passing.
   * */

  if (value) {
    const inputValue = value.toLowerCase();

    const excludeValues = typeof exclude === 'object' ? Object.values(exclude) : exclude;
    const exclusions = [].concat(excludeValues).map((value) => value.toString().toLowerCase());

    const includesValue = exclusions.some((exclusion) => inputValue.includes(exclusion));

    return includesValue ? `Must exclude "${exclusions.join(', ')}"` : null;
  }

  return null;
}
